<template>
  <div class="m-login-c" ms-controller="m_login">
    <div class="login-content f-width">
      <div class="login-img">
        <img src="/static/home/login-t.png" alt="">
      </div>
      <div class="login-form">
        <div class="login-head clearfix">
          <div class="item-1">会员登录</div>
          <router-link tag="a" class="item-2" :to="{name:'register'}">新用户注册</router-link>
        </div>
        <el-form :model="form" :rules="rules" :ref="form.formname" class="login-form-ul" style="text-align:center; margin:0 auto;">
          <el-form-item prop="LoginName">
            <el-input placeholder="登录名/邮箱" size="medium" v-model="form.LoginName">
              <template slot="prepend">
                帐号
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="LoginPassword">
            <el-input id="password" placeholder="登陆密码" size="medium" type="password" v-model="form.LoginPassword">
              <template slot="prepend">
                密码
              </template>
            </el-input>
          </el-form-item>
          <el-row>
            <el-col style="float:left; width:auto;font-size: 14px;color: #9d9d9d;">
              <el-checkbox v-model="form.remember">一周内记住帐号</el-checkbox>
            </el-col>
            <el-col style="float:left; width:auto; font-size:14px;padding-left:100px;">
              <a href="/home/forget" target="_self"> 忘记密码？</a>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="50" style="text-align:center; width:320px;">
              <el-button type="button" style="width:100%" v-on:click="loginClick('loginform')">立即登录</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import constant from '@/common/constant'

export default {
  data () {
    return {
      title: '登陆',
      form: {
        formname: 'loginform',
        LoginName: '',
        LoginPassword: '',
        remember: true
      },
      rules: {
        LoginName: [
          { required: true, message: '请输入网站登陆名', trigger: 'blur' }
        ],
        LoginPassword: [
          { required: true, message: '请输入网站登陆密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      var logininfo = this.$cookies.get('logininfo')
      if (logininfo !== null && logininfo !== undefined) {
        if (logininfo.remember) {
          this.form.LoginName = logininfo.loginname
          this.form.LoginPassword = logininfo.loginpassword

          if (this.form.LoginName !== '') {
            this.form.remember = logininfo.remember
          }
        }
      }
    },
    loginClick: function (formName) {
      var data = {
        LoginName: this.form.LoginName,
        LoginPassword: this.form.LoginPassword
      }
      var self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$ajax.post(self.constant.openPaths.login, data)
            .then(function (res) {
              if (res.data.code === 200) {
                if (self.form.remember) {
                  var logininfo = {
                    loginname: self.form.LoginName,
                    loginpassword: self.form.LoginPassword,
                    remember: self.form.remember
                  }
                  self.$cookies.set('logininfo', logininfo, 60 * 60 * 24 * 7)
                }
                self.$cookies.set('userinfo', res.data.result, 60 * 60 * 2)
                self.$router.push({ name: 'etms' })
              } else if (res.data !== null) {
                self.$message.error(res.data.msg)
              } else { }
            })
        }
      })
    }
  }
}
</script>

<style>
.m-login-c {
  margin: 0 auto;
  height: 750px;
  width: 100%;
  background-image: url(/static/home/login-bg-1.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.login-content {
  margin: 0 auto;
  height: 100%;
  display: table;
}

.login-content:after {
  height: 100%;
}

.login-content:after,
.login-content > div {
  display: table-cell;
  vertical-align: middle;
}

.login-content:after,
.login-tt:after,
.m-account-h:after,
.more-login-icon:after,
.reg2-tts > div:after {
  content: "";
}

.login-content > div {
  text-align: center;
}

.login-form {
  width: 400px;
  text-align: center;
}

.m-login-c form {
  display: block;
  position: relative;
}

.clearfix {
  zoom: 1;
}

.login-head {
  width: 100%;
  height: 60px;
  background-color: #fff;
  border-bottom: 2px solid #e8e8e8;
}

.login-head .item-1 {
  font-size: 18px;
  color: #383738;
  font-weight: bold;
  width: 118px;
  height: 59px;
  line-height: 59px;
  border-bottom: 3px solid #6583fb;
  text-align: center;
  float: left;
  *display: inline;
  margin-left: 20px;
}

.login-head .item-2 {
  color: #6583fb;
  font-size: 16px;
  float: right;
  *display: inline;
  margin-right: 30px;
  margin-top: 35px;
}

.login-form-ul {
  width: 100%;
  background-color: #fff;
  padding: 30px 0;
  margin: 0;
}

.login-form-ul > li {
  padding: 12px;
  position: relative;
}

.m-login-c ul,
.m-login-c menu,
.m-login-c dir {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

.m-login-c li {
  list-style: none;
}

.error-div,
.success-div {
  position: absolute;
  left: 35px;
  bottom: 198px;
  /* bottom: 103px; */
  color: #ff5d5d;
  font-size: 12px;
}

.m-login-c .el-row {
  padding: 12px 30px 12px 30px;
  margin: 0 auto;
}

.m-login-c .el-input {
  width: 320px;
  height: 45px;
  margin: 0 auto;
}

.m-login-c .el-input--medium .el-input__inner {
  height: 45px;
  line-height: 45px;
}

.m-login-c .el-button {
  background: #6583fb;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  color: white;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}

.m-login-c .el-form-item__error {
  margin: 0 auto;
  padding-left: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/login.vue